import {
  AnnouncementPermissionSet,
  ChargePermissionSet,
  DriverBreakPermissionSet,
  DriverUserPermissionSet,
  DutyDelayPermissionSet,
  DutyPermissionSet,
  EventPermissionSet,
  FavoriteLocationPermissionSet,
  FleetPermissionSet,
  GtfsRealtimePermissionSet,
  JourneyPermissionSet,
  OperationalAlertsPermissionSet,
  PaymentMethodPermissionSet,
  PaymentMethodTypePermissionSet,
  PermissionSetType,
  PlatformPermissionSet,
  PromoPermissionSet,
  RequestPermissionSet,
  ReviewPermissionSet,
  RiderDriverRestrictionPermissionSet,
  RiderRiderRestrictionPermissionSet,
  RiderUserPermissionSet,
  ServicePermissionSet,
  SidebarProductVisibilityPermissionSet,
  UserBanPermissionSet,
  VehiclePermissionSet,
} from '../sets'

/**
 * Ensure that at the root level of the role, we only add permission sets to it and not
 * individual permissions. Individual permissions at this level will not get assigned to the role.
 * If individual permissions are required, create a permission set of one permission and add to the role.
 */
export const OperationsAssistantRole: PermissionSetType[] = [
  PlatformPermissionSet.UsePortal,
  SidebarProductVisibilityPermissionSet.ShowOperationsProduct,
  PlatformPermissionSet.ViewSensitiveInformation, // BETA, do not assume this is functional everywhere

  DriverUserPermissionSet.View,
  DriverUserPermissionSet.Edit,
  DriverUserPermissionSet.WriteDriverBehaviour,
  DriverUserPermissionSet.Delete,
  RiderUserPermissionSet.View,
  RiderUserPermissionSet.New,
  RiderUserPermissionSet.Edit,
  RiderUserPermissionSet.Archive,
  RiderUserPermissionSet.Delete,
  UserBanPermissionSet.View,
  UserBanPermissionSet.Write,
  EventPermissionSet.View,
  AnnouncementPermissionSet.Write,
  AnnouncementPermissionSet.View,
  OperationalAlertsPermissionSet.Subscribe,
  RequestPermissionSet.View,
  RequestPermissionSet.Write,
  RequestPermissionSet.WriteRestricted,
  RequestPermissionSet.LockToDuty,
  RequestPermissionSet.Rematch,
  RequestPermissionSet.ManualIntervention,
  RequestPermissionSet.ViewDiscounts,
  RequestPermissionSet.Estimate,
  RequestPermissionSet.EstimateWithOverrides,
  RequestPermissionSet.CreateUnmatchedRequest,
  JourneyPermissionSet.View,
  JourneyPermissionSet.Write,
  FavoriteLocationPermissionSet.View,
  FavoriteLocationPermissionSet.Edit,
  FavoriteLocationPermissionSet.Delete,
  VehiclePermissionSet.View,
  VehiclePermissionSet.New,
  VehiclePermissionSet.Edit,
  VehiclePermissionSet.ViewInspection,
  DutyPermissionSet.View,
  DutyPermissionSet.New,
  DutyPermissionSet.Edit,
  DutyPermissionSet.Cancel,
  DutyPermissionSet.Delete,
  DutyPermissionSet.ViewVehicleLocation,
  DutyPermissionSet.CompleteSlot,
  DutyPermissionSet.StartDriverConversation,
  DutyPermissionSet.ViewDriverConversation,
  DriverBreakPermissionSet.View,
  DriverBreakPermissionSet.ViewReason,
  DriverBreakPermissionSet.Write,
  DriverBreakPermissionSet.WriteReason,
  DriverBreakPermissionSet.DeleteReason,
  DutyDelayPermissionSet.View,
  RiderDriverRestrictionPermissionSet.View,
  RiderDriverRestrictionPermissionSet.Create,
  RiderDriverRestrictionPermissionSet.Delete,
  RiderRiderRestrictionPermissionSet.View,
  RiderRiderRestrictionPermissionSet.Create,
  RiderRiderRestrictionPermissionSet.Delete,
  ReviewPermissionSet.View,
  GtfsRealtimePermissionSet.ViewVehiclePositions,
  PaymentMethodTypePermissionSet.View,
  PaymentMethodPermissionSet.View,
  PaymentMethodPermissionSet.Delete,
  PaymentMethodPermissionSet.CollectDirectly,
  PaymentMethodPermissionSet.InitiatePhoneCollection,
  ChargePermissionSet.View,
  ChargePermissionSet.Refund,
  PromoPermissionSet.View,
  PromoPermissionSet.ApplyToUser,
  ServicePermissionSet.View,
  FleetPermissionSet.View,
]
